import { createContext } from "react";

const ContextWeb3 = createContext();

export default ContextWeb3;
